export const ANNUAL_REPORT_DOCUMENT_TYPES = {
  ANNUAL_FINANCIAL_REPORT: {
    value: "annual_financial_report",
    readableName: "Annual Financial Report",
  },
  FORM_10K: {
    value: "form_10k",
    readableName: "Form 10K",
  },
};

export const annualReportDocumentTypesArray = Object.values(ANNUAL_REPORT_DOCUMENT_TYPES);
